import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import useIsMounted from 'ismounted'
import { Node } from 'prosemirror-model'
import { ExportClient } from 'api/clients/ExportClient'
import { ProsePreview } from 'common/ProsePreview/ProsePreview'
import { ArticleStyle } from 'types'
import Styles from './Preview.module.scss'
import { schema } from 'prose-core'
import cx from 'classnames'
import { ImagePreview } from 'common/Prose/nodeViews/Image/Image'
import { useReactNodeViewPortals } from 'common/Prose/nodeViews/ReactNodeView/ReactnodeViewPortalsContext'
import { reactNodeViewFactory } from 'common/Prose/nodeViews/utils/reactNodeViewFactory'
import { ReactNodeViewPortalsProvider } from 'common/Prose/nodeViews'

const PreviewContent = () => {
  const { format, jwt } = useParams<{ format: string; jwt: string }>()
  const [nodes, setNodes] = useState<Node[]>([])
  const [articleStyle, setArticleStyle] = useState<ArticleStyle>()
  const [workspaceArticleStyle, setWorkspaceArticleStyle] = useState<ArticleStyle>()
  const { createPortal, removePortal } = useReactNodeViewPortals()
  const makeReactNodeViewFn = reactNodeViewFactory(createPortal, removePortal, false)
  const isMounted = useIsMounted()

  useEffect(() => {
    ExportClient.getSnapshot(jwt).then((response) => {
      isMounted.current &&
        setNodes(response.data.article.elements.map((item: any) => Node.fromJSON(schema, item.data_json)))
      isMounted.current && setArticleStyle(response.data.article.article_style)
      isMounted.current && setWorkspaceArticleStyle(response.data.article.workspace_article_style)
    })
  }, [jwt, isMounted])

  return (
    <div
      id="export-preview-container"
      data-testid="export-container"
      className={cx(Styles.root, {
        [Styles.pdfExportContainer]: format === 'pdf',
        [Styles.previewPngExportContainer]: format === 'preview_png',
        [Styles.htmlExportContainer]: !['pdf', 'preview_png'].includes(format),
      })}
    >
      {nodes.length ? (
        <ProsePreview
          schema={schema}
          nodes={nodes}
          articleStyles={[workspaceArticleStyle, articleStyle]}
          removeMarks={[schema.marks.comment, schema.marks.task]}
          nodeViews={{
            image: makeReactNodeViewFn(ImagePreview),
          }}
        />
      ) : null}
    </div>
  )
}

const Preview = () => {
  return (
    <ReactNodeViewPortalsProvider>
      <PreviewContent />
    </ReactNodeViewPortalsProvider>
  )
}

export default Preview
